import { Route } from "react-router-dom"
import PrivacyPolicy from "./PrivacyPolicy"
import TOS from "./TOS"

export const commonRoutes =[
        <Route path="privacy-policy" element={<PrivacyPolicy />} />,
        <Route path="tos" element={<TOS />} />,
    
]